import Request from './Request.js';

class Proxy {
    static create() {
        return new Proxy();
    }

    activateUser({key}) {
        return this.request({api: 'activate user', params: {key}});
    }

    authenticateEmailUser({email, password}) {
        return this.authenticateUser({username: email, password});
    }

    authenticateGuest() {
        return this.authenticateUser();
    }

    authenticateInstitution(params) {
        var authenticate = () => this.request({api: 'authenticate institution', params});

        this.reauthenticateInstitution = authenticate;

        return authenticate();
    }

    authenticateLibraryCardUser(cardNumber) {
        return this.authenticateUser({cardNumber});
    }

    authenticateUser(params = {}) {
        return this.request({api: 'authenticate user', params});
    }

    confirmEmail({key}) {
        return this.request({api: 'confirm user/username', params: {key}});
    }

    createAccount({email, password}) {
        return this.request({api: 'register user', params: {username: email, password}});
    }

    async getInstitution(params = {}) {
        await this.authenticateInstitution(params);

        var data = await this.request({api: 'get institution'}),
            systemNotification = await this.request({api: 'get system'}).then(({notification}) => notification);

        return {...data, systemNotification};
    }

    request({api, params}) {
        var createRequest = () => Request.create({api, params}),
            canReauthenticateInstitution = $.isFunction(this.reauthenticateInstitution),
            isAuthenticateInstitutionApi = api === 'authenticate institution';

        if (!canReauthenticateInstitution || isAuthenticateInstitutionApi) {
            return createRequest();
        }

        return createRequest().catch(error => {
            if (error.hasType('Unauthorized')) {
                return this.reauthenticateInstitution().then(() => createRequest());
            }

            throw error;
        });
    }

    requestPasswordReset({email}) {
        return this.request({api: 'reset user/password', params: {username: email}});
    }

    resendActivationEmail({email}) {
        return this.request({api: 'resend user/activationEmail', params: {username: email}});
    }
}

export default Proxy;